export const EMOTION_GROUPS = [
  {
    id: 'orange',
    colors: ['#FCE7D3', '#FFC88F', '#FFAD7B'],
    emotions: ['Интерес', 'Ожидание', 'Настороженность'],
  },
  {
    id: 'yellow',
    colors: ['#FFF0BE', '#FFE082', '#FFD664'],
    emotions: ['Безмятежность', 'Радость', 'Восторг'],
  },
  {
    id: 'lightGreen',
    colors: ['#EFF7EC', '#D8EBCF', '#AED6A4'],
    emotions: ['Принятие', 'Доверие', 'Восхищение'],
  },
  {
    id: 'green',
    colors: ['#E4ECF4', '#C9D9E8', '#A7BED8'],
    emotions: ['Тревога', 'Страх', 'Ужас'],
  },
  {
    id: 'blue',
    colors: ['#DEF4F1', '#BCE6E2', '#98D1CC'],
    emotions: ['Растерянность', 'Удивление', 'Изумление'],
  },
  {
    id: 'darkBlue',
    colors: ['#EAF1FF', '#CFDFFD', '#ABC8F3'],
    emotions: ['Грусть', 'Печаль', 'Горе'],
  },
  {
    id: 'violet',
    colors: ['#E5DDF2', '#CCC1E2', '#AFA2D7'],
    emotions: ['Скука', 'Неудовольствие', 'Отвращение'],
  },
  {
    id: 'pink',
    colors: ['#F4DBE5', '#E1B7C8', '#D49AB1'],
    emotions: ['Досада', 'Злость', 'Гнев'],
  },
  {
    id: 'brown',
    colors: ['#F9DFDD', '#E9B9B8', '#D58B8A'],
    emotions: ['Смущение', 'Стыд', 'Вина'],
  },
];

export const flattenEmotionOptions = () => {
  const options = [];

  EMOTION_GROUPS.forEach((group, groupIndex) => {
    group.emotions.forEach((label, emotionIndex) => {
      options.push({
        id: `${group.id}-${emotionIndex}`,
        label,
        color: group.colors[emotionIndex],
        spectrumId: group.id,
        groupIndex,
        emotionIndex,
      });
    });
  });

  return options;
};
